import { SidekickSupportedTms } from '@shared/generated/graphql';
import { SupportedEntityType, TMSPageInfo } from './types';

export function getAljexPageInfo(dom: string, domIframe: string): TMSPageInfo {
  const domContent = dom ?? domIframe;

  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.ALJEX,
    entityInfo: getEntityInfo(domContent),
  };
}

const getEntityInfo = (domContent: string) => {
  const shipmentPattern: RegExp =
    /<span[^>]*id=["']headpro["'][^>]*>&nbsp;(\d+)&nbsp;<\/span>/;
  const shipmentMatch: RegExpMatchArray | null =
    domContent.match(shipmentPattern);

  if (shipmentMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: shipmentMatch[1],
      },
    ];
  }

  return [];
};
